// @flow

import React, {useState} from 'react';
import {makeStyles} from '@material-ui/core';
import ChatTabs from './ChatTabs/ChatTabs';
import TasksContent from './TasksContent/TasksContent';
import ChatContent from './ChatContent/ChatContent';

const useStyles = makeStyles(() => ({
  root: {
    height: '100%',
    width: '100%',
    borderRight: '1px solid #E8E8ED',
    display: 'flex',
    overflow: 'hidden',
    flexDirection: 'column',
  },
}));

export default function ChatGrid() {
  const classes = useStyles();

  const [tabSelected, setTabSelected] = useState(0);

  return (
    <div className={classes.root}>
      <ChatTabs value={tabSelected} setTabSelected={setTabSelected} />
      {tabSelected ? <TasksContent /> : <ChatContent useAppRootForScroll />}
    </div>
  );
}

ChatGrid.propTypes = {};
